import {BlockBuilder} from '../classes/blockBuilder';
import {BlockType} from '../classes/blockType';

export const placeholder = new BlockType({
  name: '*',
  title: 'Placeholder',
  compatibility: ['page', 'mail'],
  builder: () => BlockBuilder.create('*').flag('placeholder'),
});
